import {
	type Container,
	type ISourceOptions,
	MoveDirection,
	OutMode,
} from "@tsparticles/engine";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import React from "react";
import { useEffect, useMemo, useState } from "react";

import { Outlet } from "react-router";
import { loadFull } from "tsparticles";

const ParticlesEffect = () => {
	const [init, setInit] = useState(false);

	// this should be run only once per application lifetime
	useEffect(() => {
		initParticlesEngine(async (engine) => {
			// you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
			// this loads the tsparticles package bundle, it's the easiest method for getting everything ready
			// starting from v2 you can add only the features you need reducing the bundle size
			//await loadAll(engine);
			await loadFull(engine);
			// await loadSlim(engine);
			//await loadBasic(engine);
		}).then(() => {
			setInit(true);
		});
	}, []);

	const options: ISourceOptions = useMemo(
		() => ({
			background: {
				color: "#000000",
			},
			fullScreen: {
				enable: true,
				zIndex: -1,
			},
			particles: {
				number: {
					value: 100,
				},
				color: {
					value: "#393939",
				},
				life: {
					count: 1,
					duration: {
						value: 5,
					},
				},
				shape: {
					type: "char",
					options: {
						char: {
							font: "Courier",
							fill: true,
							value: "ABCDEFGHIJKLMNOPQRSTUVWXYZ<>[]{}()!@#$%^&*".split(""),
						},
					},
				},
				opacity: {
					value: 1,
				},
				size: {
					value: 13,
				},
				move: {
					enable: true,
					speed: 6,
					decay: 0.008,
					direction: MoveDirection.outside,
					straight: true,
					outModes: OutMode.destroy,
					trail: {
						enable: true,
						length: 5,
						fill: {
							color: "#000000",
						},
					},
				},
			},
			emitters: {
				position: {
					x: 50,
					y: 50,
				},
				size: {
					width: 100,
					height: 100,
				},
				rate: {
					quantity: 10,
					delay: 0.1,
				},
			},
		}),
		[],
	);

	if (init) {
		return <Particles id="tsparticles" options={options} />;
	}

	return <></>;
};

export const TuiLayout = () => {
	return (
		<div className="flex items-center justify-center min-h-screen">
			<div
				className="w-full max-w-md p-4 bg-background rounded-lg shadow-lg border border-ring"
				style={{ fontFamily: "monospace" }}
				tabIndex={-1}
			>
				<Outlet />
				<ParticlesEffect />
			</div>
		</div>
	);
};
